import React from 'react';
import './StatCard.css';

function StatCard({ label, value, sub, color = 'var(--accent)', icon }) {
  return (
    <div className="stat" style={{ '--sc': color }}>
      <div className="stat-top">
        <span className="stat-overline">{label}</span>
        <span className="stat-ico">{icon}</span>
      </div>
      <div className="stat-val">{value}</div>
      <div className="stat-sub">{sub}</div>
    </div>
  );
}

export default StatCard;
